export class TdoTableFooterDataModel {
  value: any;
  tdStyle: string;
}
